export default {
  data() {
    return {
      // 加载状态
      filterFlag: false,
      scrollFlag: false,
      isEnd: false,
      // 分页
      pageNum: 1,
      total: 0,
      itemList: [],
    };
  },
  mounted() {
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd) {
        if (this.filterFlag) {
          this.getList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.getList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
  }
};
